export default __webpack_public_path__ + "static/media/maintenance.26df4eec.png";